import * as CONSTANT from "../util/constants";
import { getLocation, getLatLongFromText } from "../util/location";
import "isomorphic-fetch";
require("es6-promise").polyfill();

export function requestGeolocation() {
  return {
    type: CONSTANT.REQUEST_GEOLOCATION
  };
}

export function requestGeolocationSuccess(pos) {
  return {
    type: CONSTANT.REQUEST_GEOLOCATION_SUCCESS,
    pos,
    updatedAt: new Date()
  };
}

export function requestGeolocationFailure(err) {
  return {
    type: CONSTANT.REQUEST_GEOLOCATION_FAILURE,
    err
  };
}

export function updateGeolocation() {
  return dispatch => {
    dispatch(requestGeolocation());
    const success = pos => {
      dispatch(requestGeolocationSuccess(pos));
    };
    const error = err => {
      dispatch(requestGeolocationFailure(err));
    };
    getLocation(success, error);
  };
}

export function updateMetarLocation(lat, long, name) {
  return dispatch => {
    if (!name) {
      const nameAPIUrl =
        "https://maps.googleapis.com/" +
        "maps/api/geocode/json?latlng=" +
        lat +
        "," +
        long +
        "&key=" +
        CONSTANT.GOOGLE_API_KEY;
      return fetch(nameAPIUrl)
        .then(res => {
          if (res.status !== 200) {
            throw new Error("location name lookup failed");
          }
          return res.json();
        })
        .then(
          json => {
            if (json && json.results.length > 0) {
              name = json.results[0].formatted_address;
            }
            dispatch({
              type: CONSTANT.UPDATE_METAR_LOCATION,
              lat,
              long,
              name,
              updatedAt: new Date()
            });
          },
          err => null
        );
    } else {
      dispatch({
        type: CONSTANT.UPDATE_METAR_LOCATION,
        lat,
        long,
        name,
        updatedAt: new Date()
      });
    }
  };
}

export function searchAndUpdateMetarLocation(name) {
  return dispatch => {
    var latLongName = getLatLongFromText(name);
    if (latLongName.lat && latLongName.long) {
      return dispatch(updateMetarLocation(latLongName.lat, latLongName.long));
    } else {
      const locAPIUrl =
        "https://maps.googleapis.com/" +
        "maps/api/geocode/json?address=" +
        encodeURIComponent(name) +
        "&key=" +
        CONSTANT.GOOGLE_API_KEY;
      return fetch(locAPIUrl)
        .then(res => {
          if (res.status !== 200) {
            throw new Error("location coordinate lookup failed");
          }
          return res.json();
        })
        .then(
          json => {
            if (json.results && json.results.length > 0) {
              const result = json.results[0];
              const name = result.formatted_address;
              const lat = result.geometry.location.lat;
              const long = result.geometry.location.lng;
              return dispatch(updateMetarLocation(lat, long, name));
            }
          },
          err => null
        );
    }
  };
}

export function updateGeoAndMetarLocation() {
  return dispatch => {
    dispatch(requestGeolocation());
    const success = pos => {
      dispatch(requestGeolocationSuccess(pos));
      return dispatch(
        updateMetarLocation(pos.coords.latitude, pos.coords.longitude)
      );
    };
    const error = err => {
      return dispatch(requestGeolocationFailure(err));
    };
    return getLocation(success, error);
  };
}

export function updateMetar(icao) {
  const _updateMetar = () => {
    return {
      type: CONSTANT.UPDATE_METAR,
      icao
    };
  };
  const _updateMetarSuccess = (icao, data) => {
    return {
      type: CONSTANT.UPDATE_METAR_SUCCESS,
      icao,
      data,
      updatedAt: new Date()
    };
  };
  const _updateMetarFailure = (icao, error) => {
    return {
      type: CONSTANT.UPDATE_METAR_FAILURE,
      icao,
      error,
      updatedAt: new Date()
    };
  };
  return dispatch => {
    dispatch(_updateMetar());
    return fetch(
      `https://avwx.rest/api/metar/${icao}?token=${CONSTANT.AVWX_API_KEY}`
    )
      .then(res => {
        return res.json();
      })
      .then(json => {
        if (json.Error) {
          return dispatch(_updateMetarFailure(icao, json.Error));
        } else {
          return dispatch(_updateMetarSuccess(icao, json));
        }
      })
      .catch(err => {
        return dispatch(_updateMetarFailure(icao, err.message));
      });
  };
}

export function addEphemeralMetar(icao, name) {
  return {
    type: CONSTANT.ADD_EPHEMERAL_METAR,
    icao,
    name
  };
}

export function addAndUpdateEphemeralMetar(icao, name) {
  return dispatch => {
    dispatch(addEphemeralMetar(icao, name));
    dispatch(updateMetar(icao));
  };
}



// WEBPACK FOOTER //
// ./src/actions/actions.js